
import React from 'react';
import { useAuth } from 'src/auth/AuthContext';
import { Project } from 'src/api/Api';

type Resource = Project;

interface PermissionGuardProps {
  children: React.ReactNode;
  resource?: Resource;
  resourceType: 'project';
  permission: 'delete';
}

const hasPermission = (
  userId: string | undefined,
  isAdmin: boolean,
  isUser: boolean,
  isEmployee: boolean,
  permission: string,
  resourceType: string,
  resource?: Resource
): boolean => {
  if (!userId) return false;

  switch (resourceType) {
    case 'project':
      switch (permission) {
        case 'delete':
          return Boolean(resource && (isAdmin || isUser || isEmployee));
        default:
          return false;
      }
    default:
      return false;
  }
};

export const PermissionGuard: React.FC<PermissionGuardProps> = ({
  children,
  resource,
  resourceType,
  permission,
}) => {
  const { isAdmin, isUser, isEmployee, userId } = useAuth();

  if (hasPermission(userId, isAdmin, isUser, isEmployee, permission, resourceType, resource)) {
    return <>{children}</>;
  }

  return null;
};
